import * as api from 'api/email';

export const fetchEmailTemplates = () => ({
  type: 'FETCH_EMAIL_TEMPLATES',
  payload: api.fetchEmailTemplates(),
});
